<div class="px-4 py-8" style="background-image: url('/assets/images/home_bg.png');">
  <div class="flex flex-wrap relative overflow-hidden items-center justify-center h-full">
    <div class="w-12 lg:w-6 flex">
      <div class="box text-center mt-4"
        style="background-color: rgba(220, 234, 254, 0.5); border-radius: 4%; width: 50%; margin: 0 auto; box-shadow: var(--home-card-shadow);">
         <div class="text-center mt-4">
          <img src="assets/loghi/logo_home.png" alt="Ates" height="130" class="align-self-center mt-2">
        </div>
        <div class=" text-center mt-2 text-home font-['Poppins'] " >
          Benvenuto in MEASURA!
        </div>
        <p class="px-2 py-2 line-height-3 text-center mx-auto text-sub_home" style="max-width:500px">Il portale per la
          gestione delle misurazioni interferometriche di FRAGILE.</p>

        <div style="text-align: center; display: flex; justify-content: center; align-items: bottom ">
          <button type="button" pButton label="ACCEDI" class=" mt-6 mb-2 "
            style="background-color: #6c092c; width: 40%; border-color: #6c092c;" (click)="loginWithRedirect()"></button>
        </div>
      </div>
    </div>
    <div class="w-13 lg:w-6 text-center lg:text-right overflow-hidden">
      <ng-lottie [options]="lottieConfig" (animationCreated)="animationCreated($event)"></ng-lottie>
    </div>
  </div>
  <div class="mt-8 text-align: center; ">
    <div class="text-center text-home font-light font-['Poppins']" style="font-weight: bold;">Powered by</div>
    <div style="text-align: center; display: flex; justify-content: center; align-items: bottom; ">
      <img src="assets/loghi/logo_latitude.png" alt="Image" height="40" class="align-self-center"
        style="cursor: pointer;" (click)="goToVertical()">
    </div>
  </div>
</div>
